/**
 * Standard error class for Bkper API errors.
 * Extends Error to enable instanceof checks and standard error handling.
 *
 * @public
 */
export class BkperError extends Error {
    constructor(code, message, reason) {
        super(message);
        this.name = 'BkperError';
        this.code = code;
        this.reason = reason;
    }
}
//# sourceMappingURL=BkperError.js.map